import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, Moon, Sun, User, LogOut, Settings } from 'lucide-react';
import { useUIStore } from '../../stores/uiStore';
import { useAuthStore } from '../../stores/authStore';

export const Header: React.FC = () => {
  const { theme, toggleTheme, unreadCount } = useUIStore();
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const notifRef = useRef<HTMLDivElement>(null);
  const { notifications = [], markAllNotificationsRead: markAllRead } = useUIStore() as any;

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (notifRef.current && !notifRef.current.contains(e.target as Node)) {
        setNotifOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="header-actions">
        <div className="cost-ticker">
          <span className="cost-ticker-label">עלות יומית:</span>
          <span>$0.00</span>
        </div>

        <button className="header-btn" onClick={toggleTheme} title="החלפת ערכת נושא">
          {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
        </button>

        <div style={{ position: 'relative' }} ref={notifRef}>
          <button className="header-btn" title="התראות" onClick={() => setNotifOpen((v) => !v)}>
            <Bell size={18} />
            {unreadCount > 0 && (
              <span className="notification-badge">{unreadCount > 9 ? '9+' : unreadCount}</span>
            )}
          </button>
          {notifOpen && (
            <div style={{
              position: 'absolute',
              top: '44px',
              insetInlineEnd: 0,
              width: '320px',
              background: 'var(--bg-secondary)',
              border: '1px solid var(--border)',
              borderRadius: 'var(--radius-md)',
              boxShadow: 'var(--shadow)',
              zIndex: 1000,
              maxHeight: '400px',
              overflowY: 'auto',
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: '1px solid var(--border)' }}>
                <strong style={{ fontSize: '0.9rem' }}>התראות</strong>
                {notifications.length > 0 && (
                  <button onClick={() => markAllRead?.()} style={{ background: 'transparent', border: 0, color: 'var(--accent)', fontSize: '0.8rem', cursor: 'pointer' }}>
                    סמן הכל כנקרא
                  </button>
                )}
              </div>
              {notifications.length === 0 ? (
                <div style={{ padding: '24px 16px', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.85rem' }}>
                  אין התראות חדשות
                </div>
              ) : (
                notifications.map((n: any) => (
                  <div key={n.id} style={{ padding: '10px 16px', borderBottom: '1px solid var(--border)', fontSize: '0.85rem' }}>
                    <div style={{ fontWeight: 600 }}>{n.title}</div>
                    <div style={{ color: 'var(--text-muted)' }}>{n.message}</div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        <div className="user-menu" ref={dropdownRef}>
          <button
            className="user-avatar"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <User size={18} />
          </button>

          {dropdownOpen && (
            <div className="user-dropdown">
              {user && (
                <>
                  <div style={{ padding: '8px 12px', borderBottom: `1px solid var(--border)`, marginBottom: 4 }}>
                    <div style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-primary)' }}>
                      {user.name}
                    </div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>
                      {user.email}
                    </div>
                  </div>
                </>
              )}
              <button
                className="user-dropdown-item"
                onClick={() => {
                  setDropdownOpen(false);
                  navigate('/settings');
                }}
              >
                <Settings size={16} />
                <span>הגדרות</span>
              </button>
              <div className="user-dropdown-divider" />
              <button className="user-dropdown-item danger" onClick={handleLogout}>
                <LogOut size={16} />
                <span>התנתקות</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};
